import { useMutation, useQuery } from "@tanstack/react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { AxiosError, AxiosResponse } from "axios";

import Services from "./services";
import useNotification from "../../utils/useNotification";
import constants from "./constants";
import { ErrorObj } from "../../utils/types";
import { setupAuthAxios } from "../../config/axios";
import { useApiConfig } from "../../context/apiConfigContext";
import { LocationState } from "../../utils/types";
import Enums from "./enums";
import globalConstant from "../../utils/constants";

export const useGetVisitId = () => {
  return useQuery([constants.visitIdKey], Services.getVisitId, {
    staleTime: Infinity,
  });
};

export const useGetOTP = () => {
  const toast = useNotification();
  return useMutation(Services.getOTP, {
    onError: (error: AxiosError) => {
      const errObj: ErrorObj = error.response!.data as ErrorObj;

      toast({ description: errObj.errorMsg, status: Enums.Error });
    },
    onSuccess: (data: AxiosResponse) => {
      toast({
        description: Enums.OTP_SENT_MESSAGE,
        status: Enums.Success,
        title: Enums.OTP_SENT_TITLE,
      });
    },
  });
};

export const useVerifyOTP = () => {
  const toast = useNotification();
  const location = useLocation();
  const navigate = useNavigate();
  const { updateAuthToken, baseUrl } = useApiConfig();

  let from = (location.state as LocationState)
    ? (location.state as LocationState).from!.pathname
    : "/";

  return useMutation(Services.verifyOTP, {
    onError: (error: AxiosError) => {
      const errorObj: ErrorObj = error.response!.data as ErrorObj;

      toast({ description: errorObj.errorMsg, status: Enums.Error });
    },

    onSuccess: (data : any) => {
      setupAuthAxios(baseUrl, data.auth);
      updateAuthToken(data.auth);
      localStorage.setItem(globalConstant.ORCA_USER, JSON.stringify(data.user));
      navigate(from, { replace: true });
    },
  });
};
